import { sortBasedOnDOMPosition as O, getDocument as w } from "./DTR5TSDJ.js";
import { throwOnConflictingProps as y, createStore as P, setup as S, init as C, batch as h } from "./BCALMBPZ.js";
import { defaultValue as A, chain as E } from "./PBFD2E7P.js";
import { __spreadProps as M, __spreadValues as g } from "./3YLGPPWQ.js";
function q(n) {
  var I;
  const c = n.find((u) => !!u.element), m = [...n].reverse().find((u) => !!u.element);
  let r = (I = c == null ? void 0 : c.element) == null ? void 0 : I.parentElement;
  for (; r && (m != null && m.element); ) {
    if (m && r.contains(m.element))
      return r;
    r = r.parentElement;
  }
  return w(r).body;
}
function D(n) {
  return n == null ? void 0 : n.__unstablePrivateStore;
}
function j(n = {}) {
  var I;
  y(n, n.store);
  const c = (I = n.store) == null ? void 0 : I.getState(), m = A(
    n.items,
    c == null ? void 0 : c.items,
    n.defaultItems,
    []
  ), r = new Map(m.map((e) => [e.id, e])), u = {
    items: m,
    renderedItems: A(c == null ? void 0 : c.renderedItems, [])
  }, F = D(n.store), i = P(
    { items: m, renderedItems: u.renderedItems },
    F
  ), v = P(u, n.store), p = (e) => {
    const t = O(e, (d) => d.element);
    i.setState("renderedItems", t), v.setState("renderedItems", t);
  };
  S(v, () => C(i)), S(i, () => h(i, ["items"], (e) => {
    v.setState("items", e.items);
  })), S(i, () => h(i, ["renderedItems"], (e) => {
    let t = !0, d = requestAnimationFrame(() => {
      const { renderedItems: s } = v.getState();
      e.renderedItems !== s && p(e.renderedItems);
    });
    if (typeof IntersectionObserver != "function")
      return () => cancelAnimationFrame(d);
    const l = () => {
      if (t) {
        t = !1;
        return;
      }
      cancelAnimationFrame(d), d = requestAnimationFrame(() => p(e.renderedItems));
    }, x = q(e.renderedItems), o = new IntersectionObserver(l, { root: x });
    for (const s of e.renderedItems)
      s.element && o.observe(s.element);
    return () => {
      cancelAnimationFrame(d), o.disconnect();
    };
  }));
  const _ = (e, t, d = !1) => {
    let l;
    return t((o) => {
      const s = o.findIndex(({ id: a }) => a === e.id), f = o.slice();
      if (s !== -1) {
        l = o[s];
        const a = g(g({}, l), e);
        f[s] = a, r.set(e.id, a);
      } else
        f.push(e), r.set(e.id, e);
      return f;
    }), () => {
      t((o) => {
        if (!l)
          return d && r.delete(e.id), o.filter(({ id: a }) => a !== e.id);
        const s = o.findIndex(({ id: a }) => a === e.id);
        if (s === -1) return o;
        const f = o.slice();
        return f[s] = l, r.set(e.id, l), f;
      });
    };
  }, b = (e) => _(
    e,
    (t) => i.setState("items", t),
    !0
  );
  return M(g({}, v), {
    registerItem: b,
    renderItem: (e) => E(
      b(e),
      _(
        e,
        (t) => i.setState("renderedItems", t)
      )
    ),
    item: (e) => {
      if (!e) return null;
      let t = r.get(e);
      if (!t) {
        const { items: d } = i.getState();
        t = d.find((l) => l.id === e), t && r.set(e, t);
      }
      return t || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: i
  });
}
export {
  j as createCollectionStore
};
//# sourceMappingURL=EO4GVUA4.js.map
